// Shared "capturedpropertydetails" cookie — written both ways: by the
// public "List Your Property" form as the visitor fills in their address,
// and by the House Prices tool when they type a postcode there — each
// side reads it back to pre-fill the other, for whichever one the
// visitor used first.
const COOKIE_NAME = "capturedpropertydetails";
const COOKIE_MAX_AGE_DAYS = 30;

export function setCapturedPropertyDetails(details) {
  try {
    const json = JSON.stringify(details);
    const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(json)}; max-age=${maxAge}; path=/; SameSite=Lax`;
  } catch {
    // ignore — cookies unavailable (e.g. privacy mode)
  }
}

export function getCapturedPropertyDetails() {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    if (!match) return null;
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

// Shallow-merges `patch` into whatever's already captured, so writing a
// postcode from one side never wipes out address fields the other side
// already saved.
export function mergeCapturedPropertyDetails(patch) {
  const existing = getCapturedPropertyDetails() || {};
  setCapturedPropertyDetails({ ...existing, ...patch });
}
